import React from 'react'
import { ProjectIndexRecord } from '@/search/types'
import { BaseSearchHit } from './BaseSearchHit'
import { HighlightHit } from './HighlightHit'
import { ResponsiveSearchImage } from './ResponsiveSearchImage'
import { SearchHitTextBlock } from './SearchHitTextBlock'
import { BaseSearchHitProps } from './types'

export const ProjectSearchHit: React.FC<BaseSearchHitProps<ProjectIndexRecord>> = ({ hit }) => {
  return (
    <BaseSearchHit hit={hit}>
      <ResponsiveSearchImage src={hit.thumbnailUrl} alt={hit.name} />
      <SearchHitTextBlock
        label={<HighlightHit hit={hit} attribute="name" />}
        caption={<HighlightHit hit={hit} attribute="projectType" />}
      />
    </BaseSearchHit>
  )
}
